import { ICurrency } from '../../models/Currency'
import { AuthorizationActions } from '../userAccount/actionNames'
import { CurrencyActions } from './actionNames'
import initialStore from './initialState'
import requestForCurrencyIsAccepted from './mutators/requestForCurrencyIsAccepted'

export default function(
  store: Readonly<ICurrencyStore> = initialStore,
  action: any,
): ICurrencyStore {
  switch (action.type) {
    case CurrencyActions.RequestForCurrencyIsAccepted:
      return requestForCurrencyIsAccepted(store, action)

    case AuthorizationActions.FlushState:
      return { ...initialStore }
  }
  return store
}

export interface ICurrencyStore {
  currency: ICurrency[]
}
